<template>
  <NuxtLayout>
    <NuxtPage />
    <RatingOverlay />
  </NuxtLayout>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.3s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
<script setup lang="ts">
import RatingOverlay from "@/components/RatingOverlay.vue";
useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }
  ],
})
</script>
